module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/DWzFAz/tc-custom/9781423610229.jpg?1707017813035",
      "alt": "This image is the cover for the book Marshmallows"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Marshmallows\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Need s’more ideas on what to do with this luscious ingredient? Find over 100 recipes—plus directions on how to make your own marshmallows!")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" No girl or boy scout has had marshmallows like these! "), _c('i', [_vm._v("Marshmallows")]), _vm._v(" takes the classic favorite to a mouthwatering new level. Featuring over 100 recipes for making your own marshmallows and treats to go with them, the book presents creations ranging from the family favorite S'Mores to the uniquely delicious Blood Orange and Rosemary and Zinfandel Fluff. There's even a recipe for a champagne marshmallow wedding cake! "), _c('br'), _vm._v(" "), _c('br'), _c('i', [_vm._v("Marshmallows")]), _vm._v(" also supplies readers with helpful sections on ingredients, equipment, tips and techniques, a history of the marshmallow, and much more."), _c('br'), _vm._v(" "), _c('br'), _c('i', [_vm._v("Includes photos")])])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Eileen Talanian\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Eileen Talanian is an entrepreneurial pastry chef who has served on the board of directors of the Philadelphia chapters of the American Institute of Wine and Food and Les Dames d’Escoffier International.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Gibbs Smith\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0